export default __webpack_public_path__ + "static/icon-tile-size-light-d00eb9bde6bdc4a871dd4962906630d2.png";